class CrossStorageRequest {
  public id: number;
  public key: string;

  constructor(id: number, key: string) {
    this.id = id;
    this.key = key;
  }
}

class CrossStorageRequestEntry {
  public request: CrossStorageRequest;
  public callback: (key: string, value: string) => void;

  constructor(request: CrossStorageRequest, callback: (key: string, value: string) => void) {
    this.request = request;
    this.callback = callback;
  }
}

export class CrossStorage {
  private origin: string;
  private path: string;
  private iframe: any;
  private iframeReady: boolean;
  private queue: any[];
  private requests: { [key: string]: CrossStorageRequestEntry };
  private id: number;

  constructor(origin: string, path: string) {
    this.origin = origin;
    this.path = path;
    this.iframe = null;
    this.iframeReady = false;
    this.queue = [];
    this.requests = {};
    this.id = 0;
  }

  private init(): void {
    if (!this.iframe) {
      if (window.postMessage && window.localStorage) {
        this.iframe = document.createElement('iframe');
        this.iframe.style.cssText = 'position:absolute;width:1px;height:1px;left:-9999px;';
        document.body.appendChild(this.iframe);

        if (window.addEventListener) {
          this.iframe.addEventListener('load', () => { this.iframeLoaded(); }, false);
          window.addEventListener('message', (event) => { this.handleMessage(event); }, false);
        } else if (this.iframe.attachEvent) {
          this.iframe.attachEvent('onload', () => { this.iframeLoaded(); }, false);
        }
      } else {
        throw new Error('Unsupported browser.');
      }
    }

    this.iframe.src = this.origin + this.path;
  }

  public requestValue(key: string, callback: (key: string, value: string) => void) {
    const requestEntry = new CrossStorageRequestEntry(new CrossStorageRequest(++this.id, key), callback);

    if (this.iframeReady) {
      this.sendRequest(requestEntry);
    } else {
      this.queue.push(requestEntry);
    }

    if (!this.iframe) {
      this.init();
    }
  }

  private sendRequest(requestEntry: CrossStorageRequestEntry): void {
    this.requests[requestEntry.request.id] = requestEntry;
    this.iframe.contentWindow.postMessage(JSON.stringify(requestEntry.request), this.origin);
  }

  private iframeLoaded(): void {
    this.iframeReady = true;

    if (this.queue.length) {
      for (let i = 0, len = this.queue.length; i < len; i++) {
        this.sendRequest(this.queue[i]);
      }
      this.queue = [];
    }
  }

  private handleMessage(event: any): void {
    if (event.origin === this.origin) {
      const data = JSON.parse(event.data);
      this.requests[data.id].callback(data.key, data.value);
      delete this.requests[data.id];
    }
  }
}
